import { useState } from 'react'
import { Link } from 'react-router-dom'

function Navbar() {
  const [sticky, setSticky] = useState(false)
  const [mobile, setMobile] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 150) {
      setSticky(true)
    } else {
      setSticky(false)
    }
  }

  window.addEventListener('scroll', handleScroll)

  const goTop = () => {
    window.scrollTo({
      top: (0, 0),
      behavior: 'smooth',
    })
  }

  const openMobile = () => {
    setMobile(!mobile)
  }

  return (
    <>
      <nav className={sticky ? 'sticky-nav' : ''}>
        <div className='navbar'>
          <Link to='/'>
            <p onClick={goTop}>CRYPTOFLOW</p>
          </Link>
          <ul>
            <li>
              <a href='/#home'>Home</a>
            </li>
            <li>
              <a href='/#market'>Market</a>
            </li>
            <li>
              <a href='/#choose-us'>Choose Us</a>
            </li>
            <li>
              <a href='/#join'>Join</a>
            </li>
          </ul>
          <span>
            <i className='fa-brands fa-twitter'></i>
            <i className='fa-brands fa-discord'></i>
            <i
              onClick={openMobile}
              className='fa-solid fa-bars-staggered hamburger-menu'
            ></i>
          </span>
        </div>
      </nav>
      <div className={`mobile-nav ${mobile ? 'mobile-up' : ''}`}>
        <i onClick={openMobile} className='fa-solid fa-xmark close-mobile'></i>
        <ul>
          <li onClick={openMobile}>
            <a href='/#home'>Home</a>
          </li>
          <li onClick={openMobile}>
            <a href='/#market'>Market</a>
          </li>
          <li onClick={openMobile}>
            <a href='/#choose-us'>Choose Us</a>
          </li>
          <li onClick={openMobile}>
            <a href='/#join'>Join</a>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Navbar
